import {param2Obj} from '@/utils'

const userMap = {
    admin: {
        data:{
            roles: ['admin'],
            token: 'admin',
        },
        code:200
        // introduction: '我是超级管理员',
        // avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
        // name: 'Super Admin'
    },
    editor: {
        data:{
            roles: ['editor'],
            token: 'editor',
        },
        code:200
        // introduction: '我是编辑',
        // avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
        // name: 'Normal Editor'
    },
    test: {
        data:{
            roles: ['test'],
            token: 'test',
        },
        code:200
        // introduction: '我是测试',
        // avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
        // name: 'Normal Editor'
    }
}

export default {
    loginByUsername: config => {
        const {username} = JSON.parse(config.body);
        return userMap[username]
    },
    getUserInfo: config => {
        const {token} = param2Obj(config.url);
        if (userMap[token]) {
            return userMap[token]
        } else {
            return false
        }
    },
    logout: () => {
        return {code:200}
    },

}
